import { LogoutService } from "@app/services/Logout.service";
import { VersionCheckService } from "@app/services/VersionCheck.service";
import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { PushPopService } from "@app/services/push.pop.service";
import { WindowToken } from "@app/util/window.token";
import { Router } from "@angular/router";
import { UserStore } from "@app/services/stores/UserStore";

@Component({
    selector: 'app-moo-menu',
    template: require('./menu.html')
})
export class MenuComponent {

    @Input() mainNavItems: any[] = [];
    @Input() currentSection: any;
    @Output() menuChanged: EventEmitter<string> = new EventEmitter();

    appVersion: string;
    private moreLinks: any = [
        { text: 'My Account', tid: 'MyAccount', route: '/more/myaccount' },
        { text: 'Terms and Conditions', tid: 'TermsAndConditions', route: '/more/termsAndConditions' },
        { text: 'Privacy & Security', tid: 'PrivacyPolicy', onclick: this.openPrivacyUrl },
        { text: 'Frequently Asked Questions', tid: 'FrequentlyAskedQuestions', route: '/more/FAQ' },
        { text: 'About First Citizens Bank', tid: 'AboutMutualBank', route: '/more/about' },
        { text: 'Logout', tid: 'Logout', onclick: this.logoutService.logout }
    ];

    constructor(
        @Inject(LogoutService) private logoutService: LogoutService,
        @Inject(VersionCheckService) private versionCheckService: VersionCheckService,
        @Inject(WindowToken) private window,
        @Inject(PushPopService) private pushPopService: PushPopService,
        @Inject(Router) private router: Router,
        @Inject(UserStore) private userStore: UserStore
    ) {
        this.appVersion = this.versionCheckService.localVersion();
    }

    closeSubMenu(newLocation) {
        this.menuChanged.emit('closeSubMenu');
        this.router.navigateByUrl(newLocation);
    }

    navToTab(section) {
        this.menuChanged.emit('closeSubMenu');
        this.pushPopService.navToTab(section);
    }

    onclick(listener) {
        this.menuChanged.emit('closeSubMenu');
        listener.apply(this);
    }

    openPrivacyUrl() {
        let url = 'https://www.firstcitizens.com/privacy-security/';
        this.window.open(url, '_blank');
    }
}

